module.exports = __webpack_public_path__ + "static/img/guolv.4a3068db.png";